export default __webpack_public_path__ + "static/media/chevron-left.64681703.svg";